import React from 'react';
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Page5 from "./Page5";
import Page6 from "./Page6";
import Page7 from "./Page7";
import Page8 from "./Page8";
import {scrollToTop} from "../../../../../../libs/helpers";
import Page9 from "./Page9";
import Page10 from "./Page10";
import Page11 from "./Page11";

export default class HowToIdentifyPersonalLearningStyles extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 'Page1',
            pageData: props.pagesData?.['HowToIdentifyPersonalLearningStyles']?.data || null
        };
    }

    pages = {
        Page1: Page1,
        Page2: Page2,
        Page3: Page3,
        Page4: Page4,
        Page5: Page5,
        Page6: Page6,
        Page7: Page7,
        Page8: Page8,
        Page9: Page9,
        Page10: Page10,
        Page11: Page11
    }

    handleChangePage = (currentPage) => _ => {
        this.setState({
            currentPage
        });

        scrollToTop();
    }

    handleChangePageData = (event) =>  {

        this.setState({
            pageData: {
                ...this.state.pageData,
                [event.target.name]: +event.target.value
            }
        });
    }

    savePageData = (nextPage) => () => {

        let pageData =  JSON.parse(JSON.stringify(this.state.pageData));

        this.handleChangePage(nextPage)();

        if (JSON.stringify(this.state.pageData) !== JSON.stringify(this.props.pagesData?.['HowToIdentifyPersonalLearningStyles']?.data)) {

            if (nextPage === 'Page7') {

                const openness = (pageData?.Item1 || 0) + (pageData?.Item10 || 0) +  (pageData?.Item19 || 0) +  (pageData?.Item28 || 0) + (pageData?.Item37 || 0);
                const diverging = (pageData?.Item2 || 0) + (pageData?.Item11 || 0) + (pageData?.Item20 || 0) + (pageData?.Item29 || 0) +  (pageData?.Item38 || 0);
                const conscientiousness = (pageData?.Item3 || 0) + (pageData?.Item12 || 0) + (pageData?.Item21 || 0) + (pageData?.Item30 || 0) +  (pageData?.Item39 || 0);
                const assimilating = (pageData?.Item4 || 0) + (pageData?.Item13 || 0) + (pageData?.Item22 || 0) + (pageData?.Item31 || 0) +  (pageData?.Item40 || 0);
                const extroversion = (pageData?.Item5 || 0) + (pageData?.Item14 || 0) + (pageData?.Item23 || 0) + (pageData?.Item32 || 0) +  (pageData?.Item41 || 0);
                const converging = (pageData?.Item6 || 0) + (pageData?.Item15 || 0) + (pageData?.Item24 || 0) + (pageData?.Item33 || 0) +  (pageData?.Item42 || 0);
                const agreeableness = (pageData?.Item7 || 0) + (pageData?.Item16 || 0) + (pageData?.Item25 || 0) + (pageData?.Item34 || 0) +  (pageData?.Item43 || 0);
                const accommodating = (pageData?.Item8 || 0) + (pageData?.Item17 || 0) + (pageData?.Item26 || 0) + (pageData?.Item35 || 0) +  (pageData?.Item44 || 0);
                const neuroticism = (pageData?.Item9 || 0) + (pageData?.Item18 || 0) + (pageData?.Item27 || 0) + (pageData?.Item36 || 0) +  (pageData?.Item45 || 0);

                pageData = {
                    ...pageData,
                    openness,
                    diverging,
                    conscientiousness,
                    assimilating,
                    extroversion,
                    converging,
                    agreeableness,
                    accommodating,
                    neuroticism,
                    learning_style_combination : {
                        dreamer: openness +  diverging,
                        connector: openness +  assimilating,
                        inventor: openness +  converging,
                        puppy: openness +  accommodating,
                        analyst: conscientiousness + diverging,
                        list_maker: conscientiousness + assimilating,
                        piston: conscientiousness + converging,
                        monitor: conscientiousness + accommodating,
                        socialite: extroversion + diverging,
                        facilitator: extroversion + assimilating,
                        co_ordinator: extroversion + converging,
                        explorer: extroversion + accommodating,
                        sponge: agreeableness + diverging,
                        fluffy_robot: agreeableness + assimilating,
                        family: agreeableness + converging,
                        volunteer: agreeableness + accommodating,
                        jelly: neuroticism + diverging,
                        lawyer: neuroticism + assimilating,
                        rebel: neuroticism + converging,
                        yo_yo: neuroticism + accommodating
                    }
                };
            }

            this.props.savePageData()('HowToIdentifyPersonalLearningStyles', pageData);
        }
    }

    render() {

        const Page = this.pages[this.state.currentPage] || 'Page1';

        return (
            <Page handleChangePage={this.handleChangePage}
                  handleChangeMainPage={this.props.handleChangePage}
                  handleChangePageData={this.handleChangePageData}
                  incompletePage={!this.state.pageData?.status}
                  pageData={this.state.pageData}
                  savePageStatus={this.props.savePageStatus}
                  savePageData={this.savePageData}/>
        );
    }
}